import React, {
    useState,
    useEffect,
    useRef
} from 'react';

// import { makeStyles } from '@material-ui/core/styles';
// import FormHelperText from '@material-ui/core/FormHelperText';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
// import Button from '@material-ui/core/Button';
// import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
// import Checkbox from '@material-ui/core/Checkbox';


import Autocomplete from '@material-ui/lab/Autocomplete';


import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';


import Card from '@material-ui/core/Card';
// import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import Styles from '../Styles'

import { api_bd, api_bd_nr } from '../../services/Api'

import { ticketFiltersState } from '../../atoms/tickets.atom.js'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import navigationState from '../../atoms/navigate_state.atom'
import { profileData } from '../../atoms/user.atom'
import customerData from '../../atoms/customers.atom'

import NivelDeAcesso from '../NivelDeAcesso'

import CardsContadores from '../CardsContadores.js';

import ContadorTempoTratativas from './ContadorTempoTratativas';
import { msToElapsedTime } from '../../util/fns.js';
import axios from 'axios';


import AutoCompleteInput from '../AutoCompleteInput/index.js';

const { tipos_situacao, cor_tipos_situacao } = require('../../config.json')

const Paginate = (props) => {
    const bgColor = 'bg-[#3c5ca6] '
    const bgHighLightColor = 'bg-[#324d8c] '
    const hoverBgColor = 'hover:bg-[#324d8c]'
    const pages = props?.pages || 1
    const actualPage = props?.value || 1

    const pagesInterval = 4
    const firstPage = (actualPage - pagesInterval > 1) ? (actualPage - pagesInterval) : 1
    const lastPage = (actualPage + (pagesInterval) < pages) ? (actualPage + (pagesInterval)) : pages

    const arrPages = []
    for (var i = firstPage; i < (lastPage + 1); i++) {
        arrPages.push(i)
    }

    // console.log(props.pages, pages)
    return (
        <div className='flex flex-col items-center space-x-2 w-full px-[30px] mt-[20px]'>
            <p>Páginas</p>
            <nav className='w-full flex flex-row justify-center flex-wrap'>
                {firstPage > 1 &&
                    <button
                        style={{
                            width: 28,
                            borderRadius: 3,
                            color: '#fff',
                            padding: 5,
                            margin: 3
                        }}
                        className={`${props?.value === 1 ? bgHighLightColor : bgColor} ${hoverBgColor}`}
                        onClick={() => {
                            if (props.onClick) {
                                props.onClick(1)
                            }
                        }}
                    >
                        {`<<`}
                    </button>
                }
                {arrPages.map((el, index) => (
                    <button
                        key={`pag_${index}`}
                        style={{
                            width: 28,
                            borderRadius: 3,
                            color: '#fff',
                            padding: 5,
                            margin: 3
                        }}
                        className={`${props?.value === (el) ? bgHighLightColor : bgColor} ${hoverBgColor}`}
                        onClick={() => {
                            if (props.onClick) {
                                props.onClick(el)
                            }
                        }}
                    >
                        {el}
                    </button>
                ))}
                {lastPage < pages &&
                    <button
                        style={{
                            width: 28,
                            borderRadius: 3,
                            color: '#fff',
                            padding: 5,
                            margin: 3
                        }}
                        className={`${props?.value === (pages) ? bgHighLightColor : bgColor} ${hoverBgColor}`}
                        onClick={() => {
                            if (props.onClick) {
                                props.onClick(pages)
                            }
                        }}
                    >
                        {`>>`}
                    </button>
                }
            </nav>
        </div>
    )
}

function TableChamadosN(props) {

    const styles = Styles();

    const loggedUser = useRecoilValue(profileData)

    const lista_clientes = useRecoilValue(customerData)

    const [lista_chamados, set_lista_chamados] = useState({
        counter: 0,
        pages: 1,
        data: []
    })

    const intervalRef = useRef(null);

    const [device_height, set_device_height] = useState(null)

    const [device_width, set_device_width] = useState(null)

    const [loading_message, set_loading_message] = useState('Aguarde, carregando lista de chamados.....')

    const [abortController] = useState(() => new AbortController())

    const set_navigattion_state = useSetRecoilState(navigationState)

    // const [filtro_situacao, set_filtro_situacao] = useState(localStorage.getItem('filtro_situacao') || 'em_aberto')

    const [filters, setFilters] = useRecoilState(ticketFiltersState)

    const departmentLabel = {
        'noc': 'NOC',
        'dev_ent': 'DEV / ENTERPRISE',
        'cgr': 'CGR',
    }

    // const [actualPage, setActualPage] = useState(1)

    const [list_of_reverse_ID, set_list_of_reverse_ID] = useState(false)
    // const [list_of_reverse_alphabetical_title, set_list_of_reverse_alphabetical_title] = useState(false)

    // const [qtd_list_chamados, set_qtd_list_chamados] = useState([])

    const [list_users, set_list_users] = useState([])

    // const [show_lines_filtered, set_show_lines_filtered] = useState(0)

    const [enabled_getforme, set_enabled_getforme] = useState(true)

    // const [modo_monitor, set_modo_monitor] = useState(false)

    const ticketFiltersDefaultOptions = [
        { value: 'todos', label: "TODOS" },
        { value: "em_aberto", label: "EM ABERTO" },
        { value: "em_execucao", label: "EM EXECUÇÃO" },
        { value: "em_tratativa", label: "EM TRATATIVA" },
        { value: "novos_e_atribuidos", label: "NOVOS E ATRIBUÍDOS" },
        { value: "meus", label: "MEUS" },
        { value: "em_andamento", label: "EM ANDAMENTO" },
        { value: "novo", label: "NOVO" },
        { value: "pendente", label: "PENDENTE" },
        { value: "Aguardando aprovação", label: "AGUARDANDO APROVAÇÃO" },
        { value: "Aguardando auditoria", label: "AGUARDANDO AUDITORIA" },
        { value: "janela_agendada", label: "JANELA AGENDADA" },
        { value: "solucionado", label: "SOLUCIONADO" },
        { value: "fechado", label: "FECHADO" },
        { value: "follow_up", label: "FOLLOW-UP" },
        { value: "todos", label: "TODOS" },
    ]
    const ticketFiltersClientOptions = [
        { value: "em_aberto", label: "EM ABERTO" },
        { value: "em_execucao", label: "EM EXECUÇÃO" },
        { value: "em_tratativa", label: "EM TRATATIVA" },
        { value: "novos_e_atribuidos", label: "NOVOS E ATRIBUÍDOS" },
        { value: "em_andamento", label: "EM ANDAMENTO" },
        { value: "novo", label: "NOVO" },
        { value: "pendente", label: "PENDENTE" },
        { value: "Aguardando aprovação", label: "AGUARDANDO APROVAÇÃO" },
        { value: "Aguardando auditoria", label: "AGUARDANDO AUDITORIA" },
        { value: "janela_agendada", label: "JANELA AGENDADA" },
        { value: "solucionado", label: "SOLUCIONADO" },
        { value: "fechado", label: "FECHADO" },
        { value: "follow_up", label: "FOLLOW-UP" },
        { value: "todos", label: "TODOS" },
    ]

    const formatDate = (date_str) => {
        const date = new Date(date_str);  // dateStr you get from mongodb
        const dia = date.getDate();
        const mes = date.getMonth() + 1;
        const ano = date.getFullYear();

        const hora = date.getHours();
        const minuto = date.getMinutes();

        return { dia, mes, ano, hora, minuto }
    }

    const load_users = async () => {
        const lista = await api_bd.get('/users')
        set_list_users(lista.data.filter(user => (user.nivel.match(/Super|Técnico/) && user.ativo === true)).sort((a, b) => a.nome.localeCompare(b.nome)))
    }

    function notifyMe(_title, _notificObject) {
        // Verifica se o browser suporta notificações
        if (!("Notification" in window)) {
            alert("Este browser não suporta notificações de Desktop");
        }

        // Let's check whether notification permissions have already been granted
        else if (Notification.permission === "granted") {
            // If it's okay let's create a notification
            var notification = new Notification(_title, _notificObject);
        }

        // Otherwise, we need to ask the user for permission
        else if (Notification.permission !== 'denied') {
            Notification.requestPermission(function (permission) {
                // If the user accepts, let's create a notification
                if (permission === "granted") {
                    var notification = new Notification(_title, _notificObject);
                }
            });
        }

        // At last, if the user has denied notifications, and you
        // want to be respectful there is no need to bother them any more.
    }


    const load_tickets = async (show_loading = false) => {
        // console.log('carregando lista de chamados MODO SILENCIOSO')

        if (show_loading) {
            // console.log('Aguarde, carregando lista de chamados.....')
            set_loading_message('Aguarde, carregando lista de chamados.....')
        }

        const loadErrorMessage = 'Nenhum chamado encontrado para os filtros selecionados.'

        if (loggedUser.nivel === 'Cliente' || loggedUser.nivel === 'Cliente-Admin') {
            // resp = await api_bd.get(`/tickets/customer/${_situacao_tickets}`, { signal: abortController.signal })
            await api_bd_nr.get(`/tickets/customer`, {
                params: {
                    state: filters.state,
                    category: filters.category,
                    customer: loggedUser.nivel === 'Cliente-Admin' ? loggedUser.conta_master.masterUserId : loggedUser?.id,
                    uid: loggedUser?.id || false,
                    searchParam: filters?.searchParam || '',
                    page: filters?.page,
                    department: props?.department || undefined
                },
                signal: abortController.signal
            })
                .then(({ data }) => {
                    set_lista_chamados(data)
                    if (data?.data?.length === 0) {
                        set_loading_message(loadErrorMessage)
                    } else {
                        set_loading_message(false)
                    }
                }).catch(e => {
                    if (e.name === 'AbortError') {
                        console.log('Requisição cancelada')
                        return
                    }
                    console.log('load tickets error: ', e)
                    set_loading_message(loadErrorMessage)
                })
        } else {
            await api_bd_nr.get(`/tickets`, {
                params: { ...filters, uid: loggedUser?.id, department: props?.department || undefined },
                signal: abortController.signal
            }).then(({ data }) => {
                set_lista_chamados(data)
                if (data?.data?.length === 0) {
                    set_loading_message(loadErrorMessage)
                } else {
                    set_loading_message(false)
                }
            }).catch(e => {
                if (e.name === 'AbortError') {
                    console.log('Requisição cancelada')
                    return
                }
                console.log('load tickets error: ', e)
                set_loading_message(loadErrorMessage)
            })
        }
    }

    useEffect(() => {
        (async () => {
            await load_tickets(true)
            await load_users()
        })()
        const dw = document.documentElement.clientWidth
        const dh = document.documentElement.clientHeight
        set_device_width(dw)
        set_device_height(dh)

        setFilters((current) => {
            return {
                ...current, searchParam: '',
                page: 1
            }
        })

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
            abortController.abort()
        };
    }, [])


    const getForMe = async (_id_ticket, _user) => {
        try {
            await api_bd.put(`/tickets/getforme/${_id_ticket}`, _user, { signal: abortController.signal })
            await load_tickets(localStorage.getItem('filtro_situacao') || 'em_aberto')
            set_enabled_getforme(true)
        } catch (e) {
            if (e.name === 'AbortError') {
                console.log('Requisição cancelada')
                return
            }
            console.log('getForMe error: ', e)
        }
    }

    const RowTickets = () => {
        const dados = lista_chamados?.data || []

        const msToTime = (ms) => {
            let x = ms / 1000
            let secs = x % 60
            x /= 60
            let mins = x % 60
            x /= 60
            let hrs = x % 24
            x /= 24
            let days = x

            // console.log(days)

            // return Math.floor(days)-1 + 'd:'  + hrs<10 ? '0'+hrs : hrs + ':' + mins + ':' + secs
            return (`${days >= 1 ? Math.floor(days) + ' dia(s) ' : ''}${hrs < 10 ? '0' + Math.floor(hrs) : Math.floor(hrs)}:${mins < 10 ? '0' + Math.floor(mins) : Math.floor(mins)}:${secs < 10 ? '0' + Math.floor(secs) : Math.floor(secs)}`)
        }

        const calcMs = (_time_inicio, _time_fim) => {
            const date1 = Date.parse(_time_inicio)
            const date2 = Date.parse(_time_fim)
            const diffTime = date2 - date1
            return (diffTime)
        }

        const ContadorTempoTratativas = (props) => {
            let t_execucao = 0
            for (let key in props.dados) {
                if (props.dados[key].fim !== null) {
                    t_execucao += calcMs(props.dados[key].inicio, props.dados[key].fim)
                }
            }

            return (
                <>
                    {props.dados.length === 0 || t_execucao === 0 ? '00:00:00' : ''}
                    {/* {props.dados.length > 0 && t_execucao > 0 && msToTime(t_execucao)} */}
                    {props.dados.length > 0 && t_execucao > 0 && msToElapsedTime(t_execucao).str}
                </>
            )
        }

        const formatDate = (date_str) => {
            const date = new Date(date_str);
            const dia = date.getDate();
            const mes = date.getMonth() + 1;
            const ano = date.getFullYear();

            const hora = date.getHours();
            const minuto = date.getMinutes();
            return `${String(dia).padStart(2, '0')}/${String(mes).padStart(2, '0')}/${ano} às ${String(hora).padStart(2, '0')}:${String(minuto).padStart(2, '0')}`
        }

        return (
            <>
                <>
                    {dados.length > 0 &&
                        dados.map((chamado, i, array) => {
                            if (list_of_reverse_ID) {
                                chamado = array[array.length - 1 - i]
                            }

                            const meuTicket = chamado.tratativas.filter(tratativa => {
                                if (tratativa.id_usuario === loggedUser.id && tratativa.fim === null) {
                                    return tratativa
                                } else {
                                    return false
                                }
                            })

                            const tecnicosAtivos = chamado.tratativas.filter(tratativa => {
                                if (tratativa.inicio !== null && tratativa.fim === null) {
                                    return tratativa
                                } else {
                                    return false
                                }
                            })



                            return (
                                <TableRow key={chamado._id}>
                                    {dados.length === i + 1 ?
                                        <TableCell style={{ border: '2px solid #fff', borderBottomLeftRadius: 10 }} align="center">{chamado.cod_id < 10 ? '000' + chamado.cod_id : chamado.cod_id < 100 ? '00' + chamado.cod_id : chamado.cod_id < 1000 ? '0' + chamado.cod_id : chamado.cod_id}</TableCell>
                                        :
                                        <TableCell style={{ border: '2px solid #fff', borderRadius: 5 }} align="center">{chamado.cod_id < 10 ? '000' + chamado.cod_id : chamado.cod_id < 100 ? '00' + chamado.cod_id : chamado.cod_id < 1000 ? '0' + chamado.cod_id : chamado.cod_id}</TableCell>
                                    }
                                    <TableCell style={{ border: '2px solid #fff', borderRadius: 5 }} align="left" onClick={() => {
                                        set_navigattion_state({ page_content: 'ticket_detail', data: chamado })
                                    }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', cursor: 'pointer', alignItems: 'center' }}>
                                            <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                                                {chamado?.anexo?.length > 0 &&
                                                    <span style={{ fontSize: '1.3em', marginLeft: 0, marginTop: 0 }} className="material-icons">attach_file</span>
                                                }<div style={{ fontSize: '1em' }}> {chamado.titulo}</div>
                                            </div>
                                            {meuTicket.length > 0 &&
                                                <div style={{ width: '100%', display: 'flex', flexDirection: 'row', fontSize: '0.8em', color: 'grey', paddingTop: 5 }}>
                                                    Atendimento iniciado em: {formatDate(meuTicket[0].inicio)}
                                                </div>
                                            }

                                            {loggedUser.nivel.match(/Super|Técnico-Admin/i) && tecnicosAtivos.length > 0 &&
                                                <div style={{ width: '100%', display: 'flex', flexDirection: 'row', fontSize: '0.8em', color: 'grey', paddingTop: 5 }}>
                                                    Em execução por: {tecnicosAtivos.map((tecnico, i) => (`${tecnico.nome}${tecnicosAtivos[i + 1] ? ', ' : ''}`))}
                                                </div>
                                            }

                                            {chamado.situacao.titulo === 'follow_up' &&
                                                <div style={{ width: '100%', display: 'flex', flexDirection: 'row', fontSize: '0.8em', color: 'grey', paddingTop: 5 }}>
                                                    <span style={{ fontSize: '1em', marginLeft: 0 }}>Este chamado voltará para o status <b style={{ fontSize: '1em' }}> "Em Tratativa" </b> em: <b style={{ fontSize: '1em' }}>{new Date(chamado.followup.reopen_date).toLocaleDateString()}</b></span>
                                                </div>
                                            }
                                        </div>
                                    </TableCell>
                                    <TableCell style={{ border: '2px solid #fff', borderRadius: 5, fontSize: '1em' }} align="left">{chamado.nome}<br /><span style={{ marginLeft: 0, fontSize: '0.8em' }}>
                                        ({chamado.customer_name})</span>
                                    </TableCell>
                                    <TableCell style={{ border: '2px solid #fff', borderRadius: 5 }} align="left">
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: 70, maxWidth: 70 }}>
                                            <div style={{ display: 'flex', marginTop: -20, marginBottom: -20, marginLeft: -12, marginRight: 5, minHeight: 60, minWidth: 6, width: 6, backgroundColor: cor_tipos_situacao[chamado.situacao.titulo] }}></div>
                                            <div style={{ width: '100%', fontSize: '1em' }}>
                                                {tipos_situacao[chamado.situacao.titulo]}
                                            </div>
                                        </div>
                                    </TableCell>
                                    <TableCell style={{ border: '2px solid #fff', borderRadius: 5 }} align="left">
                                        <div style={{ marginTop: -4, display: 'flex', flexDirection: 'row' }}>
                                            <span
                                                style={{ margin: 2, fontSize: '1.1em', color: chamado.prioridade === 'padrão' ? "#888888" : chamado.prioridade === 'baixa' ? "#228B22" : chamado.prioridade === 'média' ? "#ff7900" : "#ff0000" }}
                                                className="material-icons">warning</span>

                                            <span style={{ margin: 2, fontSize: '1.1em', color: chamado.prioridade === 'média' ? "#ff7900" : chamado.prioridade === 'alta' ? "#ff0000" : "#888888" }}
                                                className="material-icons">warning</span>

                                            <span
                                                style={{ margin: 2, fontSize: '1.1em', color: chamado.prioridade === 'alta' ? "#ff0000" : "#888888" }}
                                                className="material-icons">warning</span>
                                        </div>
                                    </TableCell>
                                    <TableCell style={{ border: '2px solid #fff', borderRadius: 5, textAlign: 'center' }}>
                                        {formatDate(chamado.createdAt)}
                                    </TableCell>
                                    <TableCell style={{ border: '2px solid #fff', borderRadius: 5 }} align="left">
                                        {chamado.resposaveis_tecnicos.length === 0
                                            ?
                                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                {/* {(loggedUser.nivel.match(/Super|Técnico/i)) && (!chamado.situacao.titulo.match(/fechado|solucionado|encerrado_inatividade/i)) &&
                                                    <span style={{ cursor: 'pointer', marginLeft: 0, marginRight: 5, fontSize: '1.3em' }} className="material-icons" onClick={() => {
                                                        if (enabled_getforme) {
                                                            getForMe(chamado._id, loggedUser)
                                                        }
                                                        set_enabled_getforme(false)
                                                    }}>person_add_alt</span>
                                                } */}
                                                <div style={{ fontSize: '1em' }}>Sem responsável técinco</div>
                                            </div>
                                            :
                                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                <>
                                                    {/* {(() => {
                                                        let show_add = true
                                                        if (chamado.resposaveis_tecnicos.find(el => (el.id === loggedUser.id ? true : false))) { show_add = false }
                                                        return (show_add && (loggedUser.nivel.match(/Super|Técnico/i)) && (!chamado.situacao.titulo.match(/fechado|solucionado|encerrado_inatividade/i)) && <span style={{ cursor: 'pointer', marginLeft: 0, marginRight: 5, fontSize: '1.3em' }} className="material-icons" onClick={() => getForMe(chamado._id, loggedUser)}>person_add_alt</span>)
                                                    })()} */}

                                                    {(() => {
                                                        const qtd_tec = chamado.resposaveis_tecnicos.length
                                                        return qtd_tec < 3
                                                            ?
                                                            <span style={{ marginLeft: 2, fontSize: '1em' }}>{chamado.resposaveis_tecnicos.map(tech => (tech.nome)).join(', ')}</span>
                                                            :
                                                            <span style={{ marginLeft: 2, fontSize: '1em' }}>{chamado.resposaveis_tecnicos.map(tech => (tech.nome.split(' ')[0])).join(', ')}</span>

                                                    })()}
                                                </>
                                            </div>
                                        }
                                    </TableCell>
                                    <TableCell style={{ border: '2px solid #fff' }} align="left">
                                        {/* AQUIII */}
                                        <ContadorTempoTratativas dados={chamado.tratativas} />
                                    </TableCell>
                                    {dados.length === i + 1 ?
                                        <TableCell style={{ border: '2px solid #fff', borderBottomRightRadius: 10 }} align="left">
                                            {formatDate(chamado.updatedAt)}
                                        </TableCell>
                                        :
                                        <TableCell style={{ border: '2px solid #fff', borderRadius: 5 }} align="left">
                                            {formatDate(chamado.updatedAt)}
                                        </TableCell>
                                    }

                                </TableRow>
                            )
                        })
                    }
                </>
                <>
                    {dados.length === 0 &&
                        <TableRow>
                            <TableCell colSpan={9} style={{ border: '2px solid #fff', borderBottomLefTableRowadius: 10, borderBottomRightRadius: 10, textAlign: 'center' }}>
                                <span style={{ fontSize: '1em' }}>Nenhuma informação encontrada para os filtros selecionados</span>
                            </TableCell>
                        </TableRow>
                    }
                </>
            </>
        )
    }

    const RowTicketsMin = () => {
        const dados = lista_chamados?.data || []

        const msToTime = (ms) => {
            let x = ms / 1000
            let secs = x % 60
            x /= 60
            let mins = x % 60
            x /= 60
            let hrs = x % 24
            x /= 24
            let days = x

            // console.log(days)

            // return Math.floor(days)-1 + 'd:'  + hrs<10 ? '0'+hrs : hrs + ':' + mins + ':' + secs
            return (`${days >= 1 ? Math.floor(days) + ' dia(s) ' : ''}${hrs < 10 ? '0' + Math.floor(hrs) : Math.floor(hrs)}:${mins < 10 ? '0' + Math.floor(mins) : Math.floor(mins)}:${secs < 10 ? '0' + Math.floor(secs) : Math.floor(secs)}`)
        }

        const calcMs = (_time_inicio, _time_fim) => {
            const date1 = Date.parse(_time_inicio)
            const date2 = Date.parse(_time_fim)
            const diffTime = date2 - date1
            return (diffTime)
        }

        const ContadorTempoTratativas = (props) => {
            let t_execucao = 0
            for (let key in props.dados) {
                if (props.dados[key].fim !== null) {
                    t_execucao += calcMs(props.dados[key].inicio, props.dados[key].fim)
                }
            }

            return (
                <>
                    {props.dados.length === 0 || t_execucao === 0 ? '00:00:00' : ''}
                    {/* {props.dados.length > 0 && t_execucao > 0 && msToTime(t_execucao)} */}
                    {props.dados.length > 0 && t_execucao > 0 && msToElapsedTime(t_execucao).str}
                </>
            )
        }

        const formatDate = (date_str) => {
            const date = new Date(date_str);  // dateStr you get from mongodb
            const dia = date.getDate();
            const mes = date.getMonth() + 1;
            const ano = date.getFullYear();

            const hora = date.getHours();
            const minuto = date.getMinutes();
            //return {dia, mes, ano, hora, minuto}
            return `${dia < 10 ? '0' + dia : dia}/${mes < 10 ? '0' + mes : mes}/${ano} às ${hora < 10 ? '0' + hora : hora}:${minuto < 10 ? '0' + minuto : minuto}`
        }

        return (
            <>
                {dados.length > 0 &&
                    dados.map((chamado, i, array) => {
                        if (list_of_reverse_ID) {
                            chamado = array[array.length - 1 - i]
                        }

                        const meuTicket = chamado.tratativas.filter(tratativa => {
                            if (tratativa.id_usuario === loggedUser.id && tratativa.fim === null) {
                                return tratativa
                            } else {
                                return false
                            }
                        })

                        const tecnicosAtivos = chamado.tratativas.filter(tratativa => {
                            if (tratativa.inicio !== null && tratativa.fim === null) {
                                return tratativa
                            } else {
                                return false
                            }
                        })



                        return (
                            <TableRow key={chamado._id}>
                                <TableCell
                                    style={{ cursor: 'pointer', padding: 5, border: '2px solid #fff', width: 50 }}
                                    onClick={() => {
                                        set_navigattion_state({ page_content: 'ticket_detail', data: chamado })
                                    }
                                    }
                                >   <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 3, borderBottom: '1px solid #c3c3c3' }}>
                                        <div style={{ width: '30%', minWidth: 80 }}>ID:</div>
                                        <div style={{ width: '70%' }}>{chamado.cod_id < 10 ? '000' + chamado.cod_id : chamado.cod_id < 100 ? '00' + chamado.cod_id : chamado.cod_id < 1000 ? '0' + chamado.cod_id : chamado.cod_id}</div>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 3, borderBottom: '1px solid #c3c3c3' }}>
                                        <div style={{ width: '30%', minWidth: 80 }}>Titulo</div>
                                        <div style={{ width: '70%' }}>
                                            <div style={{ display: 'flex', flexDirection: 'column', cursor: 'pointer', alignItems: 'center' }}>
                                                <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                                                    {chamado?.anexo?.length > 0 &&
                                                        <span style={{ fontSize: '1.3em', marginLeft: 0, marginTop: 0 }} className="material-icons">attach_file</span>
                                                    }<div style={{ fontSize: '1em' }}> {chamado.titulo}</div>
                                                </div>
                                                {meuTicket.length > 0 &&
                                                    <div style={{ width: '100%', display: 'flex', flexDirection: 'row', fontSize: '0.8em', color: 'grey', paddingTop: 5 }}>
                                                        Atendimento iniciado em: {formatDate(meuTicket[0].inicio)}
                                                    </div>
                                                }

                                                {loggedUser.nivel.match(/Super|Técnico-Admin/i) && tecnicosAtivos.length > 0 &&
                                                    <div style={{ width: '100%', display: 'flex', flexDirection: 'row', fontSize: '0.8em', color: 'grey', paddingTop: 5 }}>
                                                        Em tratativa por: {tecnicosAtivos.map((tecnico, i) => (`${tecnico.nome}${tecnicosAtivos[i + 1] ? ', ' : ''}`))}
                                                    </div>
                                                }

                                                {chamado.situacao.titulo === 'follow_up' &&
                                                    <div style={{ width: '100%', display: 'flex', flexDirection: 'row', fontSize: '0.8em', color: 'grey', paddingTop: 5 }}>
                                                        <span style={{ fontSize: '1em', marginLeft: 0 }}>Este chamado voltará para o status <b style={{ fontSize: '1em' }}> "Em Tratativa" </b> em: <b style={{ fontSize: '1em' }}>{new Date(chamado.followup.reopen_date).toLocaleDateString()}</b></span>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 3, borderBottom: '1px solid #c3c3c3' }}>
                                        <div style={{ width: '30%', minWidth: 80 }}>Requerente:</div>
                                        <div style={{ width: '70%' }}>
                                            {chamado.nome}<br /><span style={{ marginLeft: 0, fontSize: '0.8em' }}>
                                                ({chamado.customer_name})</span>
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 3, borderBottom: '1px solid #c3c3c3' }}>
                                        <div style={{ width: '30%', minWidth: 80 }}>Situação:</div>
                                        <div style={{ width: '70%' }}>
                                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
                                                <div style={{ display: 'flex', flexDirection: 'column', flex: '0 1 auto', height: 15, marginLeft: -12, marginRight: 5, minWidth: 6, width: 6, backgroundColor: cor_tipos_situacao[chamado.situacao.titulo] }}></div>
                                                <div style={{ width: '100%', fontSize: '1em', display: 'flex', justifyContent: 'flex-start' }}>
                                                    {tipos_situacao[chamado.situacao.titulo]}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 3, borderBottom: '1px solid #c3c3c3' }}>
                                        <div style={{ width: '30%', minWidth: 80 }}>Pioridade:</div>
                                        <div style={{ width: '70%' }}>
                                            <div style={{ marginTop: -4, display: 'flex', flexDirection: 'row' }}>
                                                <span
                                                    style={{ margin: 2, fontSize: '1.1em', color: chamado.prioridade === 'padrão' ? "#888888" : chamado.prioridade === 'baixa' ? "#228B22" : chamado.prioridade === 'média' ? "#ff7900" : "#ff0000" }}
                                                    className="material-icons">warning</span>

                                                <span style={{ margin: 2, fontSize: '1.1em', color: chamado.prioridade === 'média' ? "#ff7900" : chamado.prioridade === 'alta' ? "#ff0000" : "#888888" }}
                                                    className="material-icons">warning</span>

                                                <span
                                                    style={{ margin: 2, fontSize: '1.1em', color: chamado.prioridade === 'alta' ? "#ff0000" : "#888888" }}
                                                    className="material-icons">warning</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 3, borderBottom: '1px solid #c3c3c3' }}>
                                        <div style={{ width: '30%', minWidth: 80 }}>Data de Abertura:</div>
                                        <div style={{ width: '70%' }}>
                                            {formatDate(chamado.createdAt)}
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 3, borderBottom: '1px solid #c3c3c3' }}>
                                        <div style={{ width: '30%', minWidth: 80 }}>Técnico:</div>
                                        <div style={{ width: '70%' }}>
                                            {chamado.resposaveis_tecnicos.length === 0
                                                ?
                                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                    {(loggedUser.nivel.match(/Super|Técnico/i)) && (!chamado.situacao.titulo.match(/fechado|solucionado|encerrado_inatividade/i)) &&
                                                        <span style={{ cursor: 'pointer', marginLeft: 0, marginRight: 5, fontSize: '1.3em' }} className="material-icons" onClick={() => {
                                                            if (enabled_getforme) {
                                                                getForMe(chamado._id, loggedUser)
                                                            }
                                                            set_enabled_getforme(false)
                                                        }}>person_add_alt</span>
                                                    }
                                                    <div style={{ fontSize: '1em' }}>Sem responsável técinco</div>
                                                </div>
                                                :
                                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                    <>
                                                        {(() => {
                                                            let show_add = true
                                                            if (chamado.resposaveis_tecnicos.find(el => (el.id === loggedUser.id ? true : false))) { show_add = false }
                                                            return (show_add && (loggedUser.nivel.match(/Super|Técnico/i)) && (!chamado.situacao.titulo.match(/fechado|solucionado|encerrado_inatividade/i)) && <span style={{ cursor: 'pointer', marginLeft: 0, marginRight: 5, fontSize: '1.3em' }} className="material-icons" onClick={() => getForMe(chamado._id, loggedUser)}>person_add_alt</span>)
                                                        })()}
                                                        {(() => {
                                                            const qtd_tec = chamado.resposaveis_tecnicos.length
                                                            return qtd_tec < 3
                                                                ?
                                                                <span style={{ marginLeft: 2, fontSize: '1em' }}>{chamado.resposaveis_tecnicos.map(tech => (tech.nome)).join(', ')}</span>
                                                                :
                                                                <span style={{ marginLeft: 2, fontSize: '1em' }}>{chamado.resposaveis_tecnicos.map(tech => (tech.nome.split(' ')[0])).join(', ')}</span>

                                                        })()}
                                                    </>
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 3, borderBottom: '1px solid #c3c3c3' }}>
                                        <div style={{ width: '30%', minWidth: 80 }}>Tempo de Execução:</div>
                                        <div style={{ width: '70%' }}>
                                            <ContadorTempoTratativas dados={chamado.tratativas} />
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <div style={{ width: '30%', minWidth: 80 }}>Última Atualização:</div>
                                        <div style={{ width: '70%' }}>
                                            {formatDate(chamado.updatedAt)}
                                        </div>
                                    </div>

                                </TableCell>
                            </TableRow>
                        )
                    })
                }

                {dados.length === 0 &&
                    <TableRow>
                        <TableCell colSpan={9} style={{ border: '2px solid #fff', borderBottomLefTableRowadius: 10, borderBottomRightRadius: 10, textAlign: 'center' }}>
                            <span style={{ fontSize: '1em' }}>Nenhuma informação encontrada para os filtros selecionados</span>
                        </TableCell>
                    </TableRow>
                }

            </>
        )
    }

    useEffect(() => {
        load_tickets(true)

        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }

        intervalRef.current = setInterval(async () => {
            await load_tickets(false)
        }, 30000);

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
            abortController.abort()
        };

    }, [filters])

    useEffect(() => {
        (async () => {
            await load_tickets(true)
            await load_users()
        })()

        
        setFilters((current) => {
            return {
                ...current, searchParam: '',
                page: 1
            }
        })

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
            abortController.abort()
        };
    }, [props.department])


    // console.log('lista_clientes:: ', lista_clientes)
    // console.log('list_users:: ', list_users)

    return (
        <div
            className="height_less_header"
            style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                flex: 1,
                left: 0,
                top: 0,
                maxWidth: '100%',
                padding: 5,
                justifyContent: 'center',
                alignItems: 'flex-start',
                overflowY: "auto"
            }}
        >
            <div className={styles.div_root_component} style={{ width: '100%' }}>
                <div style={{ height: 30, marginLeft: 2, marginRight: 2, marginTop: 20, display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alingItems: 'flex-start' }}>
                    <div style={{ fontSize: '1.5em', fontWeight: 'bold', marginTop: 6 }}>
                        {loggedUser.nivel.match(/Super|Técnico/i) && (
                            <>CHAMADOS {props?.department ? departmentLabel[props.department] : ''}</>
                        )}
                        {loggedUser.nivel.match(/cliente/i) && 'CHAMADOS'}
                    </div>
                </div>

                <div style={{ minWidth: 300, display: 'flex', flexDirection: 'row', flexWrap: 'wrap', fontSize: '1em', fontWeight: 'bold', marginLeft: 2, marginTop: 20, justifyContent: 'center' }}>
                    {loggedUser.nivel.match(/Super|Técnico/i) &&
                        <CardsContadores
                            style={{ maxWidth: '100%', minWidth: '100%' }}
                            set_filtro_situacao={(val) => {
                                // console.log(val)
                                setFilters(current => {
                                    return ({ ...current, state: val })
                                })
                                // set_filtro_situacao
                            }}
                            // onClick={(value)=>{

                            // }}
                            load_tickets={load_tickets}
                            department={props.department}
                        />
                    }

                    {/*DIV container FILTROS*/}
                    <div style={{ maxWidth: '94%', minWidth: '94%', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', paddingTop: 40 }}>
                        <div
                            style={{
                                width: "100%",
                                borderRadius: 5,
                                paddingLeft: 15,
                                paddingBottom: 13,
                                marginTop: 10,
                                display: 'flex',
                                // justifyContent: 'space-between',
                                // alignItems: 'center',
                                flexWrap: 'wrap',
                                backgroundColor: 'rgb(227,227,227)'
                            }}
                        >
                            <div style={{ display: 'flex', flex: '1 0 250px', flexDirection: 'row', alignItems: 'center', marginRight: 50 }}>
                                <div style={{ fontSize: '1em', marginTop: 14, paddingBottom: 6, paddingRight: 8, borderBottom: '1px solid #0007' }}>FILTRO:</div>
                                {/* <div style={{ fontSize: '1em', marginLeft: 0, marginTop: 9 }}> */}
                                <>
                                    <NivelDeAcesso visivel_para={['Técnico', 'Técnico-Admin', 'Super']}>
                                        <AutoCompleteInput
                                            options={ticketFiltersDefaultOptions}
                                            onChange={(val) => {
                                                // console.log('Valor InputAutoComplete FILTER: ', val)
                                                setFilters(current => {
                                                    return ({ ...current, state: Object.keys(val).length === 0 ? 'todos' : val.value })
                                                })
                                            }}
                                            containerClassName="relative w-full bg-transparent border-b-[#0007] border-b-[1px] pt-[13px] pb-[5px]"
                                            inputClassName="w-full border  border-transparent bg-transparent placeholder-[#000] font-normal text-[#000] outline-none focus:outline-none active:outline-none hover:outline-none"
                                            labelKey="label"
                                            valueKey="value"
                                            placeholder="TODOS"
                                            defaultValue={filters.state}
                                            value={filters.state}
                                            mapKey="fstkd"
                                        />
                                    </NivelDeAcesso>

                                    <NivelDeAcesso visivel_para={['Cliente', 'Cliente-Admin']}>
                                        <AutoCompleteInput
                                            options={ticketFiltersClientOptions}
                                            onChange={(val) => {
                                                // console.log('Valor InputAutoComplete FILTER: ', val)
                                                setFilters(current => {
                                                    return ({ ...current, state: Object.keys(val).length === 0 ? 'todos' : val.value })
                                                })
                                            }}
                                            containerClassName="relative w-full bg-transparent border-b-[#0007] border-b-[1px] pt-[13px] pb-[5px]"
                                            inputClassName="w-full border border-transparent bg-transparent placeholder-[#000] font-normal text-[#000] outline-none focus:outline-none active:outline-none hover:outline-none"
                                            labelKey="label"
                                            valueKey="value"
                                            placeholder="TODOS"
                                            defaultValue={filters.state}
                                            // value={filters.state}
                                            mapKey="fstkc"
                                        />
                                    </NivelDeAcesso>
                                </>
                                {/* </div> */}
                            </div>

                            <div style={{ display: 'flex', flex: '1 0 250px', flexDirection: 'row', alignItems: 'center', marginRight: 50 }}>
                                <div style={{ fontSize: '1em', marginTop: 14, paddingBottom: 6, paddingRight: 5, borderBottom: '1px solid #0007' }}>CATEGORIA:</div>
                                <AutoCompleteInput
                                    options={[
                                        { value: "todos", label: "TODOS" },
                                        { value: "adequa", label: "ADEQUAÇÃO" },
                                        { value: "implanta", label: "IMPLANTAÇÃO" },
                                        { value: "migra", label: "MIGRAÇÃO" },
                                        { value: "suporte", label: "SUPORTE" },
                                    ]}
                                    onChange={(val) => {
                                        // console.log('Valor InputAutoComplete User: ', val)
                                        setFilters(current => {
                                            return ({ ...current, category: Object.keys(val).length === 0 ? 'todos' : val.value })
                                        })
                                    }}
                                    containerClassName="relative w-full bg-transparent border-b-[#0007] border-b-[1px] pt-[13px] pb-[5px]"
                                    inputClassName="w-full border border-transparent bg-transparent placeholder-[#000] font-normal text-[#000] outline-none focus:outline-none active:outline-none hover:outline-none"
                                    labelKey="label"
                                    valueKey="value"
                                    placeholder="TODOS"
                                    defaultValue={filters.category}
                                    mapKey="category"
                                />
                                {/* </div> */}
                            </div>

                            {(loggedUser.nivel.match(/Super|Técnico/i)) &&
                                <div style={{ display: 'flex', flex: '1 0 250px', flexDirection: 'row', alignItems: 'center', marginRight: 50 }}>
                                    <div style={{ fontSize: '1em', marginTop: 15, paddingBottom: 5, paddingRight: 8, borderBottom: '1px solid #0007' }}>CLIENTE:</div>
                                    <AutoCompleteInput
                                        options={[{ nome: "TODOS", _id: 'todos' }, ...lista_clientes]}
                                        onChange={(val) => {
                                            // console.log('Valor InputAutoComplete Customer: ', val)
                                            setFilters(current => {
                                                return ({ ...current, customer: Object.keys(val).length === 0 ? 'todos' : val._id })
                                            })
                                        }}
                                        containerClassName="relative w-full bg-transparent border-b-[#0007] border-b-[1px] pt-[13px] pb-[5px]"
                                        // containerClassName="relative w-full bg-transparent border-b-[#0007] border-b-[1px] pt-[9px] pb-[5px]"
                                        inputClassName="w-full border border-transparent  bg-transparent placeholder-[#000] font-normal text-[#000] outline-none focus:outline-none active:outline-none hover:outline-none"
                                        labelKey="nome"
                                        valueKey="_id"
                                        placeholder="TODOS"
                                        defaultValue={filters.customer}
                                        mapKey="customers"
                                    />
                                </div>
                            }

                            {(loggedUser.nivel.match(/Super|Técnico-Admin/i)) &&
                                <div style={{ display: 'flex', flex: '1 0 250px', flexDirection: 'row', alignItems: 'center', marginRight: 50 }}>
                                    <div style={{ fontSize: '1em', marginTop: 15, paddingBottom: 5, paddingRight: 8, borderBottom: '1px solid #0007' }}>TÉCNICO:</div>
                                    <AutoCompleteInput
                                        options={[{ nome: "TODOS", _id: 'todos' }, ...list_users]}
                                        onChange={(val) => {
                                            // console.log('Valor InputAutoComplete User: ', val)
                                            setFilters(current => {
                                                return ({ ...current, analyst: Object.keys(val).length === 0 ? 'todos' : val._id })
                                            })
                                        }}
                                        containerClassName="relative w-full bg-transparent border-b-[#0007] border-b-[1px] pt-[13px] pb-[5px]"
                                        inputClassName="w-full border border-transparent bg-transparent placeholder-[#000] font-normal text-[#000] outline-none focus:outline-none active:outline-none hover:outline-none"
                                        labelKey="nome"
                                        valueKey="_id"
                                        placeholder="TODOS"
                                        defaultValue={filters.analyst}
                                        mapKey="analists"
                                    />
                                </div>
                            }

                            <div style={{ display: 'flex', flex: '1 0 250px', flexDirection: 'row', alignItems: 'center', marginRight: 50 }}  >
                                <div style={{ fontSize: '1em', marginTop: 9, paddingBottom: 0, paddingRight: 8, borderBottom: '1px solid #0007' }}>
                                    <span style={{ margin: 0, padding: 0 }} className="material-icons">search</span>
                                </div>

                                <div className="relative w-full bg-transparent border-b-[#0007] border-b-[1px] pt-[13px] pb-[5px]">
                                    <div className="relative w-full flex items-center">
                                        <input
                                            type='text'
                                            className='w-full border  border-transparent  bg-transparent placeholder-[#000] font-normal text-[#000] outline-none focus:outline-none active:outline-none hover:outline-none'

                                            onChange={(e) => {
                                                setFilters(current => {
                                                    return ({
                                                        ...current,
                                                        state: current.state !== 'todos' ? 'todos' : current.state,
                                                        category: current.category !== 'todos' ? 'todos' : current.category,
                                                        customer: current.customer !== 'todos' ? 'todos' : current.customer,
                                                        analyst: current.analyst !== 'todos' ? 'todos' : current.analyst,
                                                        searchParam: e.target.value
                                                    })
                                                })
                                            }}
                                            // size="small"
                                            // label="Filtrar por ID ou Título"
                                            placeholder='FILTRAR POR ID OU TÍTULO'
                                            value={filters.searchParam}
                                        />
                                    </div>
                                </div>
                            </div>




                        </div>



                    </div>{/* FIM DIV container filtros Filtros */}


                </div>


                {loading_message ? (
                    <div style={{ maxWidth: '100%', minWidth: '100%', display: 'flex', justifyContent: 'center' }}>
                        <Card className={styles.card} style={{ maxWidth: '94%', minWidth: '94%' }} >
                            <CardContent style={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                                <span style={{ fontSize: '1.3em' }}>{loading_message}</span>
                            </CardContent>
                        </Card>
                    </div>
                ) : (
                    <>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>

                            {/* Normal table */}
                            <TableContainer component={Paper} style={{ marginTop: 20, minWidth: 280, maxWidth: '94%' }} className='ticketsTableFull'>
                                <Table style={{ border: '1px solid #fff' }}>
                                    <TableHead style={{ backgroundColor: '#3c5ca6', borderRadius: 5 }}>
                                        <TableRow>
                                            <TableCell
                                                onClick={() => set_list_of_reverse_ID(!list_of_reverse_ID)}
                                                style={{ cursor: 'pointer', padding: 5, color: '#fff', border: '2px solid #fff', width: 50, borderTopLeftRadius: 10 }}
                                                align="center"
                                            >#</TableCell>
                                            <TableCell style={{ padding: 5, color: '#fff', border: '2px solid #fff' }} align="center">Título</TableCell>
                                            <TableCell style={{ padding: 5, color: '#fff', border: '2px solid #fff', width: 120 }} align="center">Requerente</TableCell>
                                            <TableCell style={{ padding: 5, color: '#fff', border: '2px solid #fff', width: 80 }} align="center">Situação</TableCell>
                                            <TableCell style={{ padding: 5, color: '#fff', border: '2px solid #fff', width: 80 }} align="center">Prioridade</TableCell>
                                            <TableCell style={{ padding: 5, color: '#fff', border: '2px solid #fff', width: 150 }} align="center">Data de Abertura</TableCell>
                                            <TableCell style={{ padding: 5, color: '#fff', border: '2px solid #fff', width: 150 }} align="center">Técnico</TableCell>
                                            <TableCell style={{ padding: 5, color: '#fff', border: '2px solid #fff', width: 100 }} align="center">Tempo de Execução</TableCell>
                                            <TableCell style={{ padding: 5, color: '#fff', border: '2px solid #fff', width: 100, borderTopRightRadius: 10 }} align="center">Última Atualização</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody style={{ backgroundColor: '#e3e3e3', borderRadius: 5 }}>

                                        <RowTickets />

                                    </TableBody>
                                </Table>
                            </TableContainer>


                            {/* Min Table */}
                            <TableContainer component={Paper} style={{ marginTop: 20, minWidth: 280, maxWidth: '94%' }} className='ticketsTableMin'>
                                <Table style={{ border: '1px solid #fff' }}>
                                    <TableBody style={{ backgroundColor: '#e3e3e3', borderRadius: 5 }}>
                                        <TableRow style={{ backgroundColor: '#3c5ca6' }}>
                                            <TableCell
                                                onClick={() => set_list_of_reverse_ID(!list_of_reverse_ID)}
                                                style={{ cursor: 'pointer', padding: 5, color: '#fff', border: '2px solid #fff', width: 50, borderTopLeftRadius: 10, borderTopRightRadius: 10 }}
                                                align="center"
                                            >
                                                <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
                                                    {`${list_of_reverse_ID ? 'Ordem crescente' : 'Ordem decrescente'}`}<span style={{ fontSize: '1.2em' }} className="material-icons">{`${list_of_reverse_ID ? 'arrow_upward' : 'arrow_downward'}`}</span>
                                                </div>
                                            </TableCell>
                                        </TableRow>

                                        <RowTicketsMin />


                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>

                        {/* Paginação */}
                        <Paginate
                            pages={lista_chamados.pages}
                            onClick={((value) => {
                                setFilters(current => {
                                    return ({ ...current, page: value })
                                })
                            })}
                            value={filters.page}
                        />
                    </>
                )}
            </div>
        </div>
    );
}

export default TableChamadosN;